/*
 * Pagination
 *
 * @param {Int} maxRows Limit records in one page
 * @param {String} Url Api endpoint
 * @param {Function} onChangePage Handle onchange page
 * @param {String} keyword Search value
 * @param {Boolean} needExtraData Need to send extra data to parent component
 *
 * @return {Element}
 */
<template>
  <div class="row m-t-sm" v-if="hasNext">
    <div class="flexbox justify-center">
      <a class="text--underline" @click.prevent="loadMore">
        もっと見る
      </a>
    </div>
  </div>
</template>

<script>
import PaginationService from '@/services/paginationservice'
import * as code from '@/common/code'
import Util from '@/common/utility'
export default {
  data () {
    return {
      data: [],
      allData: [],
      productData: [],
      newData: [],
      originalData: [],
      productOriginalData: [],
      extraData: null,
      currentPage: 0,
      hasNext: false,
      loader: null,
      needClear: false,
      isLoadMore: false,
      keepSort: false,
      isDestroy: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    maxRows: {
      type: Number,
      default: 50
    },
    keyword: {
      type: [String, Object],
      default: ''
    },
    needExtraData: {
      type: Boolean,
      default: false
    },
    loadingTableMode: {
      type: Boolean,
      default: false
    },
    clientMode: {
      type: Boolean,
      default: false
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    needLoading: {
      type: Boolean,
      default: true
    },
    method: {
      type: String,
      default: 'get'
    }
  },
  created () {
    const showLoading = this.needLoading && !this.clientMode
    this.fetchData(true, showLoading, false)
  },
  mounted () {
    this.$events.listen('productData', (data) => {
      if (this.url === 'Product/available' || this.url === 'Product/available_no_refresh' || this.url === 'PromotionProduct/available') {
        this.productData = [...data]
      }
    })
    this.$events.listen('productOriginalData', (data) => {
      if (this.url === 'Product/available' || this.url === 'Product/available_no_refresh' || this.url === 'PromotionProduct/available') {
        this.productOriginalData = [...data]
      }
    })
    this.$events.listen('waitData', (data, extraUrl) => {
      if (this.url === 'Product/available' || this.url === 'Product/available_no_refresh' || this.url === 'PromotionProduct/available') {
        this.allData = this.allData.map((item) => {
          const newItem = data.find(resItem => resItem.asin === item.asin)
          if (newItem) {
            if (extraUrl === 'Product/get-price') {
              return {
                ...item,
                ...newItem,
                offerPrice: this.calculateOfferPrice(item, newItem)
              }
            }
            return {
              ...item,
              ...newItem
            }
          }
          return item
        })
      }
    })
  },
  methods: {
    /*
     * Fetch data from API
     *
     * @param {Boolean} needClear Need clear all old data in table
     *
     * @return void
     */
    fetchData (needClear = false, showLoading = false, needAll = false, forceClient = false, isSearch = false) {
      this.currentPage = this.currentPage + 1
      if (showLoading) {
        this.loader = this.$loading.show({
          container: this.clientMode && this.$parent.$refs.table ? this.$parent.$refs.table : null
        })
      }
      this.needClear = needClear
      if ((!this.clientMode || this.currentPage === 1) && !needAll && !forceClient) {
        this.fetchDataByAPI(needAll, needClear)
      } else {
        this.fetchDataClientMode(false, true, null, isSearch)
        this.loader && this.loader.hide()
        this.$events.fire('done', this.url)
      }
    },
    /*
     * Handle onclick load more button
     *
     * @return void
     */
    loadMore () {
      if (!this.loader || !this.loader.active) {
        this.isLoadMore = true
        if (this.loadingTableMode) {
          this.fetchData(false, this.loadingTableMode)
        } else {
          this.loader = this.$loading.show()
          this.fetchData(false)
        }
      }
    },
    /*
     * Reload table
     *
     * @return void
     */
    reload (showLoading = false, needAll = false, forceClient = false) {
      this.currentPage = 0
      this.fetchData(true, showLoading, needAll, forceClient)
    },

    /*
     * Fetch data by calling API
     *
     * @param {Boolean} needAll Need to get all data without paginate on server-side
     *
     * @return void
     */
    fetchDataByAPI (needAll, needClear) {
      if (this.isDestroy) return
      let url = this.url
      let payload = null
      if (this.method === 'get') {
        payload = (this.clientMode || needAll) ? {} : {
          limit: this.maxRows,
          page: this.currentPage,
          ...this.keyword
        }
      } else {
        payload = {
          ...this.keyword
        }
        url = `${url}?page=${this.currentPage}&limit=${this.maxRows}`
      }
      const apiMethod = (this.method !== 'get') ? PaginationService.postDataByExtraUrl : PaginationService.getData
      apiMethod(url, payload)
        .then((response) => {
          this.allData = needClear ? [
            ...response.data
          ] : [
            ...this.allData,
            ...response.data
          ]
          this.originalData = needClear ? JSON.parse(JSON.stringify(response.data)) : JSON.parse(JSON.stringify([
            ...this.originalData,
            ...response.data
          ]))
          // this.data = [...response.data]
          if (this.clientMode) {
            this.fetchDataClientMode()
          } else {
            this.newData = [...response.data]
            this.data = needClear ? [
              ...response.data
            ] : [
              ...this.data,
              ...response.data
            ]
            // this.data = [...response.data]
            this.hasNext = this.currentPage < response.totalPage
          }
          if (this.needExtraData) {
            this.extraData = {
              coefficient: response.coefficient
            }
          }
          if (this.extraUrlMode) {
            const asinList = this.clientMode ? response.data.slice(0, this.maxRows).map(item => item.asin) : response.data.map(item => item.asin)
            this.fetchDataByExtraUrl(this.extraUrl, asinList)
          }
          this.$events.fire('noAmazon', true)
          if (this.url === 'QA/list') {
            this.$events.fire('apiSuccess', this.url, response)
          } else {
            this.$events.fire('apiSuccess', this.url)
          }
        })
        .catch((err) => {
          this.currentPage -= 1
          if (err === code.amazonInfoNotFound) {
            this.$events.fire('noAmazon', false)
          } else {
            this.$emit('zIndex', 1040)
            this.$store.commit('toggleModal', {
              show: true,
              message: err
            })
          }
        })
        .finally(() => {
          this.loader && this.loader.hide()
          this.$events.fire('done', this.url)
        })
    },

    /*
     * Fetch data in client side
     *
     * @param {Boolean} showFromStart Data start from page 1
     * @param {Boolean} rowChanged All data had changed number of recrords
     *
     * @return void
     */
    fetchDataClientMode (showFromStart = false, rowChanged = true, type = '', isSearch = false) {
      // const startPage = showFromStart ? 0 : this.currentPage - 1
      const startPage = 0
      const currentPage = this.currentPage > 0 ? this.currentPage : 1
      if (this.keyword && this.keyword.length > 0) {
        this.data = [...this.allData].filter((item) => {
          return (
            (item.asin && item.asin.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.ean && item.ean.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.productName && item.productName.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.itemName && item.itemName.toLowerCase().includes(this.keyword.toLowerCase()))
          )
          // if (item.asin && item.productName) {
          //   return item.asin.toLowerCase().includes(this.keyword.toLowerCase()) || item.productName.toLowerCase().includes(this.keyword.toLowerCase())
          // }
          // return false
        })
        if (rowChanged) {
          this.hasNext = currentPage < (this.data.length / this.maxRows)
        }
        this.data = this.data.slice(startPage * this.maxRows, currentPage * this.maxRows)
        if (this.isLoadMore || type === 'delete' || isSearch) {
          this.newData = this.data.slice((currentPage - 1) * this.maxRows, currentPage * this.maxRows)
        }
      } else {
        this.data = [...this.allData].slice(startPage * this.maxRows, currentPage * this.maxRows)
        if (rowChanged) {
          this.hasNext = currentPage < (this.allData.length / this.maxRows)
        }
        if (this.isLoadMore || type === 'delete' || isSearch) {
          this.newData = this.allData.slice((currentPage - 1) * this.maxRows, currentPage * this.maxRows)
        }
      }

      if (this.isLoadMore || type === 'delete' || isSearch) {
        const list = this.newData.filter(data => (data.image === null || data.image === undefined))
        const asinList = list.map(item => item.asin)
        this.fetchDataByExtraUrl(this.extraUrl, asinList, isSearch)
      }
    },

    /*
     * Change data by parent component
     *
     * @param {Object} item Item need to be changed
     * @param {String} type Type of change
     * @param {Boolean} isCallApi Need to call API
     *
     * @return void
     */
    handleData (item, type, isCallApi) {
      this.keepSort = !isCallApi
      this.needClear = true
      let rowChanged = true
      if (type === 'delete') {
        this.allData = this.allData.filter(data => data.asin !== item.asin)
        this.originalData = this.originalData.filter(data => data.asin !== item.asin)
      } else if (type === 'add') {
        const productItem = this.productData.find((prd) => prd.asin === item.asin)
        let newItem = productItem ? {
          ...productItem,
          ean: item.ean
        } : {...item}
        this.allData.push({
          ...newItem,
          offerPrice: this.calculateOfferPrice(newItem, newItem)
        })
      } else if (type === 'update') {
        rowChanged = false
        this.allData = this.allData.map((data) => {
          if (data.asin === item.asin && item.judgment) {
            data.judgmentStatus = item.judgment.judgmentStatusName
            data.judgmentStatusCode = item.judgment.judgmentCode
          }
          return data
        })
      } else if (type === 'deleteAll') {
        this.allData = this.allData.filter(data => !item.includes(data.asin))
        this.originalData = this.originalData.filter(data => !item.includes(data.asin))
      }
      if (!isCallApi) {
        this.fetchDataClientMode(true, rowChanged, type)
      } else {
        this.fetchNextItem()
      }
    },

    fetchNextItem () {
      if (this.isDestroy) return
      const payload = {
        limit: this.maxRows,
        page: this.currentPage
      }
      PaginationService.getData(this.url, payload)
        .then((response) => {
          if (response.data && response.data.length === this.maxRows) {
            this.allData.push(response.data[this.maxRows - 1])
            this.originalData.push(response.data[this.maxRows - 1])
            if (this.extraUrlMode) {
              const asinList = response.data.map((item) => item.asin)
              this.fetchDataByExtraUrl(this.extraUrl, asinList)
            }
          }
          this.data = [...this.allData]
          this.hasNext = this.currentPage < response.totalPage
          if (this.needExtraData) {
            this.extraData = {
              coefficient: response.coefficient
            }
          }
          this.$events.fire('noAmazon', true)
        })
        .catch((err) => {
          if (err === code.amazonInfoNotFound) {
            this.$events.fire('noAmazon', false)
          } else {
            this.$emit('zIndex', 1040)
            this.$store.commit('toggleModal', {
              show: true,
              message: err
            })
          }
        })
        .finally(() => {
          this.$events.fire('done', this.url)
        })
    },

    fetchDataByExtraUrl (urlList, asin, isSearch = false) {
      if (urlList.length > 0) {
        urlList.forEach(async (url) => {
          const {chunkData, delayTime} = this.checkInvalidData(url, asin)
          if (chunkData.length > 0 && !this.isDestroy) {
            for (const item of chunkData) {
              const payload = {
                // record: asin
                record: item
              }
              PaginationService.postDataByExtraUrl(url, payload)
                .then((response) => {
                  this.needClear = true
                  this.allData = this.allData.map((item) => {
                    const newItem = response.data.find(resItem => resItem.asin === item.asin)
                    if (newItem) {
                      if ((this.url === 'Product/available' || this.url === 'Product/available_no_refresh' || this.url === 'PromotionProduct/available') && url === 'Product/get-price') {
                        return {
                          ...item,
                          ...newItem,
                          offerPrice: this.calculateOfferPrice(item, newItem)
                        }
                      }
                      return {
                        ...item,
                        ...newItem
                      }
                    }
                    return item
                  })
                  const asinList = this.allData.map((item) => item.asin)
                  const waitData = response.data.filter((item) => !asinList.includes(item.asin))
                  if (waitData.length > 0) {
                    this.$events.fire('waitData', waitData, url)
                  }
                  this.fetchDataClientMode(true, false)
                })
                .catch((err) => {
                  this.$emit('zIndex', 1040)
                  this.$store.commit('toggleModal', {
                    show: true,
                    message: err
                  })
                })
              await Util.delay(delayTime)
            }
          }
        })
      }
    },

    checkInvalidData (extraUrl, asin) {
      let keys = []
      let maxDataPerRequest = 50
      let delayTime = 500
      switch (extraUrl) {
        case 'Product/get-price':
          keys = ['amazonPrice']
          maxDataPerRequest = 20
          delayTime = 100
          break
        case 'Product/get-image-name':
          keys = ['image']
          maxDataPerRequest = 20
          delayTime = 1000
          break
        case 'Product/get-stock-info':
          keys = ['numberOfStock']
          maxDataPerRequest = 50
          delayTime = 500
          break
        default:
          break
      }
      const matchData = this.allData.filter(item => {
        let match = false
        keys.forEach(key => {
          if (!Object.prototype.hasOwnProperty.call(item, key)) {
            match = true
          }
        })
        return asin.includes(item.asin) && match
      }).map(item => item.asin)
      const chunkData = Util.chunkArray(matchData, maxDataPerRequest)
      return {
        chunkData,
        delayTime
      }
    },

    updateOriginalData (item) {
      this.originalData = this.originalData.map(orignalItem => {
        if (orignalItem.asin === item.asin) {
          return JSON.parse(JSON.stringify(item))
        }
        return orignalItem
      })
    },

    calculateOfferPrice (currentItem, newItem) {
      if (currentItem.offerPrice === 0) {
        return newItem.amazonPrice > 0 ? Math.round(newItem.amazonPrice * 0.9) : null
      }
      return currentItem.offerPrice
    }
  },

  watch: {
    data () {
      let newData = null
      if (this.isLoadMore) {
        newData = this.newData
        this.isLoadMore = false
      }
      this.$emit('onChangePage', this.data, this.extraData, this.needClear, this.keepSort, newData)
      if (this.needClear) {
        this.needClear = false
      }
      if (this.keepSort) {
        this.keepSort = false
      }
    },
    keyword (newVal) {
      this.currentPage = 0
      const isClientSide = newVal !== null && this.clientMode
      const isSearch = (newVal !== null && newVal !== '')
      this.fetchData(true, true, isClientSide, isClientSide, isSearch)
    },
    allData (newVal) {
      if (this.url === 'Product' || this.url === 'PromotionResult/list') {
        this.$events.fire('productData', newVal)
      }
    },
    originalData (newVal) {
      this.$emit('originalData', newVal)
    },
    productData (newVal) {
      if (this.url === 'Product/available' || this.url === 'Product/available_no_refresh' || this.url === 'PromotionProduct/available') {
        this.allData = this.allData.map((item) => {
          const newItem = newVal.find(resItem => resItem.asin === item.asin)
          if (newItem) {
            return {
              ...item,
              ...newItem
            }
          }
          return item
        })
      }
      this.fetchDataClientMode(true)
    }
  },
  beforeDestroy () {
    this.isDestroy = true
    this.loader && this.loader.hide()
    this.$store.commit('toggleModal')
    this.$events.remove('productData')
    this.$events.remove('productOriginalData')
    this.$events.remove('waitData')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PaginationLoadMore.vue